import { Box, CircularProgress } from '@mui/material';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import React from 'react';
import { useTranslation } from 'react-i18next';

type ReportDescriptionProps = {
    showDescriptionDialog: boolean;
    setShowDescriptionDialog: (value: boolean) => void;
    descriptionLoading: boolean;
    descriptionData: any;
};

export const ReportDescriptionDialog: React.FC<ReportDescriptionProps> = ({
    showDescriptionDialog,
    setShowDescriptionDialog,
    descriptionLoading,
    descriptionData,
}) => {
    const { t: translate } = useTranslation(['reports', 'common']);

    return (
        <Box id="reports">
            <DHDialog
                open={showDescriptionDialog}
                onClose={() => setShowDescriptionDialog(false)}
                title={translate('REPORT_DESCRIPTION')}
                maxWidth="md"
                fullWidth
            >
                <Box sx={{ minHeight: 200 }}>
                    {descriptionLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box
                            dangerouslySetInnerHTML={{
                                __html:
                                    descriptionData?.getReportDescription ||
                                    translate('reports:NO_DESCRIPTION_AVAILABLE'),
                            }}
                        />
                    )}
                </Box>
            </DHDialog>
        </Box>
    );
};
